module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"purchase_button":"SIGN UP","show_features":"See Features","hide_features":"Hide Features"},"ja":{"purchase_button":"お申し込み","show_features":"特典を表示","hide_features":"特典を非表示"}}')
  delete Component.options._Ctor
}
